import { Wallet } from "./wallet.model";

export interface LoginDto {
  location: string;
  number: string;
  email: string;
}

export interface LoginError {
  code: number;
  message: string;
}

export interface LoginSuccess {
  status: string;
  messages: string[];
  data: {
    wallet: Wallet;
    token: string;
  };
  metadata: any;
}

export type LoginResponse = LoginSuccess | LoginError;

export interface ActivateBraceletDto {
  location: string;
  code?: number;
  number: string;
  email: string;
  firstname: string;
  lastname: string;
}

export interface LoginErrorResponse {
  status: string;
  messages: LoginErrorMessage[];
}

export interface LoginErrorMessage {
  code: LoginErrorCodeEnum;
  field: string;
  message: string;
}

export enum LoginErrorCodeEnum {
  AUTH_ERR = "AUTH_ERR",
  AUTH_MAX_ATTEMPT = "AUTH_MAX_ATTEMPT",
}